import './App.css';
import photo001 from './photo001.jpg'

//大美芙岛 地下仙境 四通八达 卫星之城 和平之邦

function App() {

  return (
    <div>
      <img src={photo001} alt='横幅' style={{width:'100%',display:"block",animationDuration:'0.5s',animationName:'FadeIn'}}/>
      <h1 className='welcome'>
      欢迎来到芙岛！  
      </h1>
      <h2 className='slogan'>
      自然之宝，宜居之境，活力之城
      </h2>

      

    </div>
  );
}

export default App;
